module.exports = __webpack_public_path__ + "static/step_3_3-103f4df4f1410f133a25cc5dfd8459b3.svg";